import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Twitters pitched 5 products, why I chose the first",
  "description": "",
  "published": "2011-06-09T00:00:00.000Z",
  "redirect_from": ["/blog/the-twitters-pitched-5-products-i-chose-the-first/swizec/1829"],
  "categories": "Apollo, Facebook, Klok, Paymo, Replicon, Social network, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A couple of days ago I decided it might be time to upgrade my time tracking software a little bit. I've been using `}<a parentName="p" {...{
        "href": "http://klok.mcgraphix.com/klok/index.htm",
        "title": "Klok"
      }}>{`Klok`}</a>{`, an AIR based desktop thingy, for quite a while now and it's getting a bit lame. Development has stopped some insanely long time ago and certain features are simply missing ... like for example syncing between devices.`}</p>
    <p>{`Naturally as any good twitter addict would do, my first reaction upon deciding this was to open the nearest twitter client and `}<a parentName="p" {...{
        "href": "http://twitter.com/#!/Swizec/status/77348484377878528"
      }}>{`ask`}</a>{` for the best time tracking software. I expected the usual; most people ignoring me like I don't exist, one or two retweeting the question and perhaps a few people telling me their personal favourite or at least someone trolling me that I'm an idiot and why would I need something like that.`}</p>
    <p>{`What happened was a lot stranger. Instead of the usual random people telling me their opinions, I got five tweets from businesses telling me to give their solution a try.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/bnJLr3.png",
        "alt": null,
        "title": "Yanomo was first"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/DILnH3.png",
        "alt": null,
        "title": "Paymo was soon after"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/mj6ki3.png",
        "alt": null,
        "title": "I still read Apollo's tweet"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/uoQke2.png",
        "alt": null,
        "title": "Fanurio was so late it just felt like spam"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/hZEh52.png",
        "alt": null,
        "title": "Replicon was so hopelessly late I didn't even notice the tweet"
      }}></img></p>
    <p>{`Being a spoiled twitter user that I am, I clicked the first two links that got to me. And I even researched both products. I signed up for Yanomo and it looked pretty damn good, almost perfect, but it didn't have a key feature I wanted - a timer to time when I'm working on things. It needs to have times inserted manually.`}</p>
    <p>{`By the time Paymo came along my mind still quite wasn't made up because of the missing feature, so they got me to click their link, check out the product and take a few very hard moments of consideration. Their problem was that everything I read, everything I saw, was immediately compared to Yanomo whereas Yanomo only had to compare against the old solution I was trying to ditch.`}</p>
    <p>{`The other guys came in a bit late, the latest was even a whole three days late and that's just obscenely too much. By that time my mind had already been made up and I was giving Yanomo a real test to see if it pans out for me or I'm going to have to search for something else.`}</p>
    <p>{`In fact, most of the other responses felt like spam. Upon seeing them my mind instantly filtered them out because all I could see was that somebody was pitching a product to me, it didn't even cross my mind that but 40 hours earlier I was asking about the very same thing! It just didn't.`}</p>
    <p>{`In the end I chose Yanomo, which I'll be using henceforth to track my billable hours and stuff ... I'll still be using Klok the same way I'm using it now - to track every productive-ish hour of my life, but which isn't exactly billable.`}</p>
    <p>{`There are two main reasons why I made the choice that I did:`}</p>
    <ol>
      <li parentName="ol">{`A very friendly and very quick tweet`}</li>
      <li parentName="ol">{`The product just looks and feels easy to use`}</li>
    </ol>
    <p>{`So there you have it, getting to your end user quickly and with something pretty, may well mean they'll choose you over the competition even if you're missing the single most important feature.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://socialb2p.com/2011/06/05/are-you-spittering-spamming-or-truly-engaging-on-twitter/"
        }}>{`Are you spittering (=spamming) or truly engaging on Twitter?`}</a>{` (socialb2p.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dorai.wordpress.com/2011/06/08/my-ideal-twitter-client/"
        }}>{`My Ideal Twitter Client`}</a>{` (dorai.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.getklok.com/"
        }}>{`Free Time Tracking Software - Klok Free and Klok Pro`}</a>{` (getklok.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=690fc9f9-6717-4a8d-8202-363dd2b20995",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      